import React, { Component } from "react";
import { Button, Checkbox, Grid, Typography, Modal } from "@material-ui/core";
import { connect } from "react-redux";
import {
  primaryColor,
  textBlack,
  textPrimary,
  webFont
} from "../../config/theme";
import FormHelperText from "@material-ui/core/FormHelperText";
import Divider from "@material-ui/core/Divider";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import { compose, graphql } from "react-apollo";
import Radio from "@material-ui/core/Radio";
import InputMask from "react-input-mask";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { CloseOutlined } from '@material-ui/icons';
import { NotificationManager } from "react-notifications";
import { ADD_USER_PAYMENT } from "../../graphql/mutations/user";
import {
  CREATE_BOOKING,
  DELETE_IN_PROGRESS_BOOKING,
  UPDATE_IN_PROGRESS_BOOKING
} from "../../graphql/mutations/booking";
import { getPaymentInfo } from "../../redux/user";
import GetCardType from "../../utils/card-type";
import {client} from "../../config/apollo";
import {pendingBooking, setPendingBooking} from "../../redux/bookings";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import AddCard from "../AddCard";


const defaultChefImg = "/images/simple-chef.webp";
const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
const amex = "/images/amex.webp";
const discover = "/images/discover.webp";
const dinersclub = "/images/dinersclub.webp";
const jcb = "/images/jcb.webp";
const mastercard = "/images/mastercard.webp";
const visa = "/images/visa.webp";
const unionpay = "/images/unionpay.webp";

class InProgress4 extends Component {
  savedForLater = false;
  clickedBookNow = false;

  constructor(props) {
    super(props);

    this.state = {
      cardType: "",
      formData: {
        cardName: "",
        validThru: "",
        cvvCode: "",
        cardNo: ""
      },
      errData: {
        cardName: "",
        validThru: "",
        cvvCode: "",
        cardNo: ""
      },
      totalAmount: 0,
      value: "",
      card: {},
      disabled: false,
      clickedBookNow: false,
      saveForLater: false,
      chef: {},
      priceRange: '',
      showCancelModal: false,
      showAddCard: false
    };

    this.onCloseAddCard = this.onCloseAddCard.bind(this);
  }

  onCloseAddCard = () => {
    this.setState({ showAddCard: false });
  };

  componentDidMount() {
    const { dispatch, userId } = this.props;
    dispatch(getPaymentInfo(userId));
    this.clickedBookNow = false;
    this.setState({disabled: false, clickedBookNow: false});
    if (window != undefined) {
      this.setState({ priceRange: window.localStorage.getItem('cc-custom-booking-price-range') })
    }
  }

  handleRadioChange = value => {
    this.clickedBookNow = false;
    this.setState({disabled: false, clickedBookNow: false});
    this.setState({ value: value });
    const { cart, updateInProgressBooking, inProgressBooking } = this.props;
    let dishes = [];
    cart.map(dish => {
      let bookingDish = {
        dishId: dish.id,
        serves: dish.serves
      };
      dishes.push(bookingDish);
    });

    let payload = {
      userId: this.props.userId,
      chefId: this.props.selectedChefId || this.props.selectedChef.id,
      dishes: dishes,
      cardId: value
    };

    updateInProgressBooking({
      variables: {
        bookingId: inProgressBooking,
        booking: payload
      }
    })
      .then(res => {

      })
      .catch(err => {
        console.log(JSON.parse(JSON.stringify(err)));
      });
  };

  handleChange = (e, name) => {
    let { errData, formData, cardType } = this.state;
    switch (name) {
      case "cardNo":
        let cNo = e.target.value.replace("-", "");
        cardType = cNo;
        if (cNo == "") {
          errData.cardNo = "This Field can not be blank ";
        } else {
          errData.cardNo = "";
        }
        formData.cardNo = e.target.value
          .split("-")
          .join("")
          .split(" ")
          .join("");
        cardType = GetCardType(cNo);
        break;
      case "validThru":
        if (e.target.value == "") {
          errData.validThru = "This Field can not be blank ";
        } else if (!expiryRegex.test(e.target.value)) {
          errData.validThru = "Invalid expiry for card. Format MM/YY";
        } else {
          errData.validThru = "";
        }
        formData.validThru = e.target.value;
        break;
      case "cvvCode":
        if (e.target.value == "") {
          errData.cvvCode = "This Field can not be blank";
        } else if (e.target.value != "" && isNaN(e.target.value)) {
          errData.cvvCode = "This is not valid cvv no";
        } else if (this.state.cardType.toLowerCase().startsWith('amex') && e.target.value.length !== 4) {
          errData.cvvCode = "This is not valid cvv no";
        } else if (!this.state.cardType.toLowerCase().startsWith('amex') && e.target.value.length !== 3) {
          errData.cvvCode = "This is not valid cvv no";
        } else {
          errData.cvvCode = "";
        }
        formData.cvvCode = e.target.value;
        break;
      case "cardName":
        formData.cardName = e.target.value;
        break;
    }
    this.setState({ errData: { ...this.state.errData, ...errData }, cardType });
    this.setState({ formData: { ...this.state.formData, ...formData }, cardType });
  };

  submitDetail = (checked) => {
    if (checked) {
      this.setState({ saveForLater: true });
      this.savedForLater = true;
      this.handleBooking();
    } else {
      this.setState({ saveForLater: false });
      this.savedForLater = false;
    }
  };

  addUserCard = () =>{
    const { addUserPayment,dispatch, userId } = this.props;
    let { formData } = this.state;
    if (!expiryRegex.test(formData.validThru)) {
      this.clickedBookNow = false;
      this.setState({disabled: false, clickedBookNow: false});
      NotificationManager.error('Invalid expiry for card. Format XX/XXXX', 'Add Card');
      return;
    }
    let enterDate = formData.validThru.split("/");

    if (
        formData.cardNo != "" &&
        formData.cvvCode != "" &&
//        formData.cardName != "" &&
        enterDate != ""
    ) {
      let payload = {
        type: "CARD",
        card: {
          number: formData.cardNo,
          expMonth: enterDate[0],
          expYear: enterDate[1],
          cvc: formData.cvvCode,
        }
      };

      if (formData.cardName !== "" && !!formData.cardName) {
        payload.card.nameOnCard =  formData.cardName;
      }

      addUserPayment({
        variables: {
          userId: this.props.userId,
          payment: payload
        }
      })
          .then(res => {

            if(res.data.addUserPayment && res.data.addUserPayment !== null) {
              this.handleRadioChange(res.data.addUserPayment);
            } else {
              NotificationManager.error("Please check if the card is already added.", "Booking");
            }
            this.clickedBookNow = false;
            this.setState({disabled: false, clickedBookNow: false});
          })
          .catch(err => {
            console.log(JSON.parse(JSON.stringify(err)));
            let errorObj = JSON.parse(JSON.stringify(err));
            console.log("ADD CARD ERR: ", errorObj);
            if (errorObj.graphQLErrors) {
              errorObj.graphQLErrors.map(error => {
                NotificationManager.error(error.message, "Booking");
              });
            }
            this.clickedBookNow = false;
            this.setState({disabled: false, clickedBookNow: false});
          });
    } else {
      NotificationManager.error("All fields are required");
      this.clickedBookNow = false;
      this.setState({disabled: false, clickedBookNow: false});
    }
  };

  handleBooking = () => {
    if (this.clickedBookNow || this.state.clickedBookNow) return;

    this.clickedBookNow = true;
    this.setState({disabled: true, clickedBookNow: true});

    if (this.savedForLater) {
      let url = "/home/diner-bookings?closeSlider=yes&step=3";
      this.props.history.push(url);
      return;
    }

    const { createBooking, inProgressBooking, dispatch, userId, parentPage } = this.props;
    const {value, cardType}=this.state;

    if (!value) {
      const { addUserPayment, userId } = this.props;
      let { formData } = this.state;
      let enterDate = formData.validThru.split("/");
      if (
          formData.cardNo != "" &&
          formData.cvvCode != "" &&
          enterDate != "" && ((cardType.toLowerCase().startsWith('amex') && formData.cvvCode.length === 4) || (!cardType.toLowerCase().startsWith('amex') && formData.cvvCode.length === 3))
      )
      {
        let payload = {
          type: "CARD",
          card: {
            number: formData.cardNo,
            expMonth: enterDate[0],
            expYear: enterDate[1],
            cvc: formData.cvvCode,
            nameOnCard: formData.cardName
          }
        };

        addUserPayment({
          variables: {
            userId: this.props.userId,
            payment: payload
          }
        })
            .then(res => {
              if(res.data.addUserPayment) {
                this.setState({ value: res.data.addUserPayment });
                const { cart, updateInProgressBooking, inProgressBooking } = this.props;
                let dishes = [];
                cart.map(dish => {
                  let bookingDish = {
                    dishId: dish.id,
                    serves: dish.serves
                  };
                  dishes.push(bookingDish);
                });

                let updatePayload = {
                  userId: this.props.userId,
                  chefId: this.props.selectedChef.id,
                  distance: "10",
                  dishes: dishes,
                  cardId: res.data.addUserPayment
                };

                updateInProgressBooking({
                  variables: {
                    bookingId: inProgressBooking,
                    booking: updatePayload
                  }
                })
                    .then(() => {
                      createBooking({
                        variables: {
                          bookingId: inProgressBooking
                        }
                      })
                          .then(() => {
                            let url = "/home/diner-bookings?closeSlider=yes&step=1";
                            this.props.history.push(url);
                            if (parentPage) {
                              if (parentPage === 'bookings' && this.props.closeBookingDrawer) {
                                this.props.closeBookingDrawer();
                              }
                            }
                            dispatch(pendingBooking(null));
                            dispatch(setPendingBooking(null));
                            this.clickedBookNow = false;
                            this.setState({disabled: false, clickedBookNow: false});
                            this.props.changeProgressStep(1);
                          })
                          .catch(err => {
                            this.setState({ disabled: false });
                            console.log(JSON.parse(JSON.stringify(err)));
                            let errorObj = JSON.parse(JSON.stringify(err));
                            if (errorObj.graphQLErrors) {
                              errorObj.graphQLErrors.map(error => {
                                if (error.message.includes('Your account cannot')) {
                                  NotificationManager.error('Chef has not completed the registration process.', 'Unable to book')
                                } else {
                                  NotificationManager.error(error.message, "Booking");
                                }
                              });
                            }

                            this.clickedBookNow = false;
                            this.setState({disabled: false, clickedBookNow: false});
                          });
                    })
                    .catch(err => {
                      console.log(JSON.parse(JSON.stringify(err)));
                      this.clickedBookNow = false;
                      this.setState({disabled: false, clickedBookNow: false});
                    });
              } else {
                NotificationManager.error("Please check if the card is already added.");
                this.clickedBookNow = false;
                this.setState({disabled: false, clickedBookNow: false});
              }
            })
            .catch(err => {
              this.setState({ disabled: false });
              console.log(JSON.parse(JSON.stringify(err)));
              let errorObj = JSON.parse(JSON.stringify(err));
              if (errorObj.graphQLErrors) {
                errorObj.graphQLErrors.map(error => {
                  if (error.message.includes('Your account cannot')) {
                    NotificationManager.error('Chef has not completed the registration process.', 'Unable to book')
                  } else {
                    NotificationManager.error(error.message, "Booking");
                  }
                });
              }
            });
      } else {
        NotificationManager.error("Please add a valid card or choose an existing.");
        this.setState({ disabled: false });
      }
    } else {
      if (this.savedForLater) {

        let url = "/home/diner-bookings?closeSlider=yes&step=3";
        this.props.changeProgressStep(1);
        this.props.history.push(url);
        if (parentPage) {
          if (parentPage === 'bookings' && this.props.closeBookingDrawer) {
            this.props.closeBookingDrawer();
          }
        }
        return;
      }
      createBooking({
        variables: {
          bookingId: inProgressBooking
        }
      })
          .then(res => {
            let url = "/home/diner-bookings?closeSlider=yes&step=1";
            this.props.changeProgressStep(1);
            this.props.history.push(url);
            if (parentPage) {
              if (parentPage === 'bookings' && this.props.closeBookingDrawer) {
                this.props.closeBookingDrawer();
                this.clickedBookNow = false;
                this.setState({ disabled: false });
              }
            }
          })
          .catch(err => {
            this.clickedBookNow = false;
            this.setState({ disabled: false });
            console.log(JSON.parse(JSON.stringify(err)));
            let errorObj = JSON.parse(JSON.stringify(err));
            if (errorObj.graphQLErrors) {
              errorObj.graphQLErrors.map(error => {
                if (error.message.includes('Your account cannot')) {
                  NotificationManager.error('Chef has not completed the registration process.', 'Unable to book')
                } else {
                  NotificationManager.error(error.message, "Booking");
                }
              });
            }
          });
    }
    this.clickedBookNow = false;
    this.setState({ disabled: false });
  };

  render() {
    const { selectedChef, cart, chef, isCustom } = this.props;
    let { totalAmount } = this.state;
    let { cuisines, profilePic, firstName, lastName } = selectedChef || chef || {};
    let chefCuisines = "";
    if (!!cuisines && cuisines.length > 0) {
      if (cuisines.length < 3) {
        chefCuisines = cuisines.join(", ");
      } else {
        chefCuisines = 'Multi Cuisines';
      }
    }

    if (!isCustom) {
      cart.forEach(dish => {
        let pricePerQty = parseFloat((dish.minPrice / dish.minDinerSize).toFixed(2));
        totalAmount += Math.round(pricePerQty * dish.serves);
      });
    }

    const { paymentInfo } = this.props;
    let userCards = <ListItem />;

    if (paymentInfo) {
      userCards = paymentInfo.map(payment => {
        return (
          <ListItem
            divider
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <p>
                ************{payment.card.last4}
              </p>
            </div>
            <div>
              <img src={payment.card.type.toLowerCase().startsWith('visa') ? visa : (
                payment.card.type.toLowerCase().startsWith('master') ? mastercard : (
                  payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ? amex : (
                    payment.card.type.toLowerCase().startsWith('disco') ? discover : (
                      payment.card.type.toLowerCase().startsWith('diner') ? dinersclub : (
                        payment.card.type.toLowerCase().startsWith('jc') ? jcb : unionpay
                      )
                    )
                  )
                )
              )} style={styles.cardImgInput} />
            </div>
            <div>
              <Radio
                data-test-id={"bkgfourradio"}
                checked={this.state.value === payment.card.cardId}
                onChange={(e)=>this.handleRadioChange(e.target.value)}
                value={payment.card.cardId}
                name="radio-button-demo"
                aria-label={payment.card.cardId}
                color="primary"
              />
            </div>
          </ListItem>
        );
      });
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              style={{
                ...styles.setFont,
                fontSize: 24,
                fontWeight: 500,
                marginBottom: 30,
                color: '#000',
              }}
            >
              Payment
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={3} md={2}>
                <img
                  src={profilePic ? profilePic : defaultChefImg}
                  style={styles.chefImg}
                  alt={"Chef Name"}
                />
              </Grid>
              <Grid  data-test-id={"chefnamefour"} item xs={6} md={6}>
                <Typography
                  style={{ ...styles.setFont, fontSize: 15, fontWeight: 400 }}
                >
                  {firstName &&  lastName ? `${firstName.toUpperCase()} ${lastName.toUpperCase()}` : ''}
                </Typography>
                <Typography>{chefCuisines}</Typography>
              </Grid>
              <Grid  data-test-id={"bkgfouramt"} item xs={3} md={3}>
                <Typography
                  style={{
                    ...styles.setFont,
                    fontSize: this.props.isCustom ? 16 : 24,
                    color: primaryColor
                  }}
                >
                  ${this.props.isCustom ? this.state.priceRange.split('-').join(' - $') : (totalAmount + parseFloat((totalAmount * 0.05).toFixed(2 ))).toFixed(2)}
                </Typography>
              </Grid>
              {!this.props.isCustom && !this.props.isRecurring && <div style={{ fontSize: 14 }}>
                You will be charged the total amount shown above, once the Chef has accepted the booking.
              </div>}

              {this.props.isCustom && <div style={{ fontSize: 14 }}>
                You will be charged only after you and the Chef have agreed on the exact cost. After submitting this, keep an eye out for the Chef's proposal in the Bookings page.
              </div>}

              <Grid  data-test-id={"cancelationbkgstep"} item xs={12} style={{ margin: '30 auto', textAlign: 'left' }}>
                <div style={{ fontSize: 12, textAlign: 'left' }}>
                  <p>
                    <strong>Cancelation Policy: </strong>
                    {chef.firstName} {chef.lastName} {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation ? ' allows ' : ' disallows '} cancelation of confirmed engagements
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge == 0 && ' without a fee.'}
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge != 0 ? <>
                    {' '}under the following terms.
                      <ul>
                        <li style={{ textAlign: 'left' }}>No cancelation charges if canceled {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} before engagement time</li>
                        <li style={{ textAlign: 'left' }}>Any cancelations within {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} of engagement time, will result in cancelation charge of {chef.cancellationPolicy.penaltyCharge}% of booking amount.</li>
                        {chef.cancellationPolicy.allowCancellation && !!chef.cancellationPolicy.comments && <li style={{ textAlign: 'left' }}>
                          {chef.cancellationPolicy.comments ? chef.cancellationPolicy.comments.toString().charAt(0).toUpperCase() + chef.cancellationPolicy.comments.slice(1) : 'No comments'}
                        </li>}
                      </ul>
                    </> : <span></span>}
                  </p>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <div style={{ width: '100%' }}>
              <form>
                <Grid container spacing={16}>
                  <Grid item md={12} xs={11} sm={12}>
                    {userCards.length > 0 && <div><Grid item md={12} xs={11} sm={12}>
                      <div>
                        <p style={styles.subHeaderText}> Saved cards </p>
                        {this.props.isRecurring && <div style={{ fontSize: 12 }}>
                          The amount charged will be for the first booking only and subsequent bookings in the series
                          will be charged 3 days prior to the next booking.
                        </div>}
                        <Divider
                          variant="inset"
                          style={{ margin: "auto", width: "100%" }}
                        />
                      </div>
                    </Grid>

                    <Grid item md={12} xs={12} sm={12}>
                      <List>{userCards}</List>
                    </Grid></div>}
                    <Grid item md={2} />
                    <Grid item md={12} style={{marginBottom: 10}}>
                      <div
                        onClick={() => this.setState({ showAddCard: true })}
                        data-test-id={"booking-step-5-use-card-btn"}
                        style={styles.addAnotherText}>Use {userCards.length > 0 ? 'another' : ''} card</div>
                    </Grid>

                    <AddCard show={this.state.showAddCard} close={this.onCloseAddCard} onSuccess={() => {}} />
                  </Grid>
                </Grid>
              </form>
            </div>
          </Grid>
        </Grid>

        <Modal open={this.state.showCancelModal} onClose={() => this.setState({ showCancelModal: false })}>
          <div className="modal-wrapper-booking-transaction-proposal">
            <div className="modal-close">
              <h3 className="modal-close-header">Cancel booking</h3>
              <button onClick={() => this.setState({ showCancelModal: false })}>
                <CloseOutlined />
              </button>
            </div>
            <p style={{ marginTop: -10, marginBottom: 10 }}>Are you sure you want to discard this booking ?</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0px', marginLeft: -7 }}>
              <Button
                data-test-id={"bkgfourdiscard"}
                disabled={this.state.disabled}
                style={{ ...styles.setFont, ...styles.cancelModalBtn }}
                onClick={() => {
                  client.mutate({
                    mutation: DELETE_IN_PROGRESS_BOOKING,
                    variables: {
                      bookingId: this.props.inProgressBooking
                    }
                  })
                  .then(() => {
                    let url = "/home/diner-bookings?closeSlider=yes&step=1";
                    this.props.history.push(url);
                  })
                  .catch(err => {});
                }}
              >
                Discard
              </Button>

              <Button
                data-test-id={"bkgfoursaveforlater"}
                disabled={this.state.disabled}
                style={{ ...styles.setFont, ...styles.cancelModalBtn }}
                onClick={() => this.submitDetail(true)}
              >
                Save for later
              </Button>
            </div>
          </div>
        </Modal>
        <Grid container justify="center" alignContent="center" style={{marginTop: 40}}>
          <Button
            data-test-id={"bkgfourcancel"}
            disabled={this.state.disabled}
            style={{ ...styles.setFont, ...styles.nextBtn }}
            onClick={() => {
              if (this.props.isRecurring) {
                client.mutate({
                    mutation: DELETE_IN_PROGRESS_BOOKING,
                    variables: {
                      bookingId: this.props.inProgressBooking
                    }
                  })
                  .then(() => {
                    let url = "/home/diner-bookings?closeSlider=yes&step=1";
                    this.props.history.push(url);
                  })
                  .catch(err => {});
              } else {
                this.setState({ showCancelModal: true });
              }
            }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid container justify="center" alignContent="center" style={{marginTop: 10}}>
          <Button
            data-test-id={"bkgfourbknow"}
            disabled={this.state.disabled || this.clickedBookNow}
            style={{ ...styles.setFont, ...styles.nextBtn }}
            onClick={() => this.handleBooking()}
          >
            Book now
          </Button>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    cart: state.bookings.cart,
    diner: state.user.diner,
    chef: state.user.chef,
    isRecurring: state.bookings.isRecurring,
    selectedChef: state.bookings.selectedChef,
    selectedChefId: state.bookings.selectedChefId,
    paymentInfo: state.user.paymentInfo,
    inProgressBooking: state.bookings.inProgressBooking
  };
};
const ProgressFourWithData = compose(
  graphql(ADD_USER_PAYMENT, { name: "addUserPayment" }),
  graphql(CREATE_BOOKING, { name: "createBooking" }),
  graphql(UPDATE_IN_PROGRESS_BOOKING, { name: "updateInProgressBooking" }),
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  }),
)(InProgress4);

const InProgressFour = connect(mapStateToProps)(ProgressFourWithData);
export default InProgressFour;

const styles = {
  cardImgInput: {
    marginLeft: 10,
    minHeight: 20,
    maxHeight: 60,
    minWidth: 71,
    maxWidth: 120,
  },
  chefImg: {
    width: 60,
    height: 60,
    objectFit: "contain",
    borderRadius: "50%"
  },
  nextBtn: {
    minWidth: 240,
    height: 48,
    textAlign: "center",
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: "#fff",
    textTransform: 'none',
    fontSize: 18,
    fontWeight: 'normal'
  },
  cancelModalBtn: {
    minWidth: 200,
    height: 48,
    textAlign: "center",
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: "#fff",
    textTransform: 'none',
    fontSize: 18,
    fontWeight: 'normal',
    margin: 3
  },
  avatarImg: {
    width: "86px",
    height: "86px",
    borderColor: primaryColor,
    borderWidth: 7
  },

  userName: {
    fontFamily: webFont,
    fontSize: "30px",
    color: textBlack,
    weight: 500,
    paddingLeft: 0,
    textAlign: "left"
  },

  ftText: {
    fontFamily: webFont,
    fontSize: "15px",
    color: textBlack,
    marginLeft: 80,
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15
  },
  ftText2: {
    fontFamily: webFont,
    fontSize: "15px",
    color: textBlack,
    marginLeft: 80,
    fontWeight: 500,
    marginTop: 15
  },
  subHeaderText: {
    fontFamily: webFont,
    fontSize: "18px",
    fontWeight: 500,
    marginBottom: 40,
    marginTop: 30
  },
  frlabel: {
    fontFamily: webFont,
    fontSize: "20px",
    color: textPrimary,
    marginLeft: 80,
    fontWeight: 500,
    marginBottom: 15,
    marginTop: 15
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    height: "62%",
    width: "90%"
  },
  setFont: {
    fontFamily: webFont
  },

  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  displayBlock: {
    display: "block"
  },
  displayNone: {
    display: "none"
  },
  error: { fontSize: 12, color: "red", fontFamily: webFont },
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "200px",
    color: "white",
    height: 40,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "500"
  },
  addAnotherText: {
    textAlign: "left",
    margin: 0,
    marginLeft: 100,
    height: 20,
    fontFamily: webFont,
    fontWeight: "normal",
    backgroundColor: primaryColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 210,
    color: '#ffffff',
    fontSize: 18,
    padding: '15px',
    borderRadius: 30,
    cursor: 'pointer'
  },
};
